










	import Vue from 'vue';
    import _users from '../../services/endpoints/users';

    export default Vue.extend({
        name: "ProgressShareComp",
        data: () => ({
            share: false
        }),
        computed: {
            switchValue: {
                get: function(): any {
                    return this.share;
                },
                set: async function(value: any): Promise<void> {
                    this.share = value;
                    await _users.setProgressShared(value);
                }
            },
        },
        created: async function() {
            this.share = await _users.hasProgressShared(null);
        }
    })
